import { useContext } from "react";
import { AppContext } from "../App";
import ProjectDetail from "../views/ProjectDetail";
import ProjectsLanding from "../views/ProjectsLanding";

export default function Projects() {
  const appContext = useContext(AppContext);

  if (
    !appContext.navSubItem &&
    !appContext.navExtraItem &&
    !appContext.navMoreItem
  ) {
    return <ProjectsLanding />;
  }

  if (appContext.navSubItem && !appContext.navExtraItem && !appContext.navMoreItem) {
    return <ProjectDetail projectSlug={appContext.navSubItem} />;
  }

  return null;
}
